import EventLobbyContainer from './EventLobby.container';

export default EventLobbyContainer;
